import {ANALYTICS} from "../../third-party-services/analytics/analytics-consts";
import {BaseModel} from "../models/base-model";

export class BaseEventConfig extends BaseModel {
  name: String;
  type: ANALYTICS.EVENT_TYPES;

  constructor(name: String, type: ANALYTICS.EVENT_TYPES) {
    super();

    this.name = name;
    this.type = type;
  }

}
